import { render, staticRenderFns } from "./AddCase.vue?vue&type=template&id=55498dca&"
import script from "./AddCase.vue?vue&type=script&lang=js&"
export * from "./AddCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports